import { Selector } from '@ngxs/store';
import _ from 'lodash';
import moment from 'moment';
import { UserStatusEnum } from 'src/app/samwebDescription/samwin/UserStatusEnum';
import { StatusType } from 'src/generated/signalR/status-type';
import { UserStatusInfoRemoteDto } from 'src/generated/signalR/user-status-info-remote-dto';
import { SamwinAcdExtensionState, SamwinAcdExtensionStateModel } from '../../samwin/samwin-acd-extension/samwin-acd-extension.state';
import { SamwinSkillsState } from '../../samwin/samwin-skills/samwin-skills.state';
import { SkillGroup } from '../../samwin/samwin-skills/skill-group';
import { SamwinUserStatusState } from '../../samwin/samwin-user-status/samwin-user-status.state';
import { SessionState } from '../../session/session.state';

export class SamwinUnreachableWarningSelectors {
   @Selector([SamwinUserStatusState.currentStatusInfo, SamwinUserStatusState.getNextAutoStatusChangeTime])
   public static isUnreachableBecauseOfUserstate(statusinfo: UserStatusInfoRemoteDto, statusChangeTime: moment.Moment): boolean {
      if (_.isNil(statusinfo)) {
         return false;
      }
      // ignore BUSY
      if (statusinfo.id === UserStatusEnum.BUSY.value) {
         return false;
      }
      // ignore automatic ACW
      const now: moment.Moment = moment();
      const hasDuration: boolean = !_.isNil(statusChangeTime) && statusChangeTime > now;
      if (statusinfo.id === UserStatusEnum.ACW.value && hasDuration) {
         return false;
      }

      if (statusinfo.type !== StatusType.LOGGED_ON_READY) {
         return true;
      }
      return false;
   }

   @Selector([SamwinSkillsState.getCallAndChatSkillGroups, SamwinUserStatusState.currentStatusInfo, SessionState.getAuthenticatedUserId])
   public static isUnreachableBecauseOfSkills(skills: SkillGroup[], statusinfo: UserStatusInfoRemoteDto, userId: number): boolean {
      // NOTE: [18572] Checks all five seconds, because skills get Updated.
      if (_.isNil(skills) || skills.length === 0) {
         return false;
      }
      if (!_.isNil(statusinfo) && !_.isNil(statusinfo.type) && statusinfo.type === StatusType.LOGGED_OFF) {
         return false;
      }
      if (_.some(skills, (s) => _.includes(s.loggedOnUserIds, userId))) {
         return false;
      }
      return true;
   }

   @Selector([SamwinUserStatusState.isAgentActive])
   public static isUnreachableBecauseOfDeactivated(isAgentActive: boolean): boolean {
      return !isAgentActive;
   }

   @Selector([
      SamwinUnreachableWarningSelectors.isUnreachableBecauseOfUserstate,
      SamwinUnreachableWarningSelectors.isUnreachableBecauseOfDeactivated,
      SamwinUnreachableWarningSelectors.isUnreachableBecauseOfSkills,
      SessionState.getUserStateNotificationwindowTreatDeactivatedAsReachable,
      SamwinAcdExtensionState,
   ])
   public static isUnreachable(
      unreachableBecauseOfUserstate: boolean,
      unreachableBecauseOfDeactivated: boolean,
      unreachableBecauseOfSkills: boolean,
      treatDeactivatedAsReachable: boolean,
      state: SamwinAcdExtensionStateModel
   ) {
      // override setting active?
      if (unreachableBecauseOfDeactivated && treatDeactivatedAsReachable) {
         return false;
      }
      // check if user is logged in and Acd Extension is selected before un-reachability is checked.
      if (_.isNil(state.assignedAcdExtension)) {
         return false;
      }
      // if user is logged in and available, has at minimum one active skill and the server userstate is active the user is available.
      if (unreachableBecauseOfUserstate || unreachableBecauseOfSkills || unreachableBecauseOfDeactivated) {
         return true;
      }
      return false;
   }
}
